import angular from 'angular';
import './section.global.css';

export const USectionComponent = angular
  .module('core.u-section', [])
  .component('uSection', {});
